
import { defineComponent, ref, reactive, onMounted, computed, toRefs } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import { Modal, notification } from "ant-design-vue";
import { useRouter } from "vue-router";
import { h } from "vue";
import Comment from './component/Comment.vue'
import dayjs, { Dayjs } from 'dayjs';
type RangeValue = [Dayjs, Dayjs];
import { debounce, remove } from 'lodash-es';
import { isTSEntityName } from "@babel/types";
import { SearchOutlined } from "@ant-design/icons-vue";

export default defineComponent({
    components: {
        Comment
    },
    
    setup() {
        const showUploadForm = ref(false);
        const router = useRouter();
        const form_action = ref("save");
        const store = useStore();

        const fields = ref([
            {
                title: "Invoice No.",
                dataIndex: "invoice_number",
                slots: { customRender: "invoice_number" },
                fixed: true,
                sorter: true,
                width: 150,
            },
            {
                title: "IBPS Transaction Number",
                dataIndex: "transaction_id",
                fixed: true,
            },
            {
                title: "Invoice Date",
                dataIndex: "invoice_date",
                sorter: true,
            },
            {
                title: "Invoice Amount",
                dataIndex: "invoice_amount",
            },
            {
                title: "PO Number",
                dataIndex: "po_number",
            },
            {
                title: "Due Date",
                dataIndex: "due_date",
            },
            {
                title: "Invoice Status",
                dataIndex: "invoice_status",
            },
            {
                title: "Requestor",
                dataIndex: "requestor",
            },
            {
                title: "PV No.",
                dataIndex: "pv_number",
            },
            {
                title: "Check No.",
                dataIndex: "check_number",
            },
            {
                title: "Check Date",
                dataIndex: "check_date",
            },
            {
                title: "Paid Amount",
                dataIndex: "invoice_amount_paid",
            },
            {
                title: "Bank Releasing Branch",
                dataIndex: "releasing_site",
            },
            {
                title: "Check Status",
                dataIndex: "check_status",
            },
            {
                title: "Comments",
                dataIndex: "comments",
                slots: { customRender: "comments" },
                align: "center",
            },
        ]);

        const loading = ref(false)
        const visible = ref(false)
        const selectedIdVendor = ref('');
        const selectedOrgIdFromVendor = ref('');
        const current_page = ref(1);
        const search = ref(null);
        const sortByColumn = ref('invoice_date');
        const sortBy = ref('ASC');

        const form = reactive({
            id:'',
            org_id: 'all',
            vendor_id: '',
            vendor_id_old: '',
            invoice_date: ref<RangeValue>(),
            invoice_no:  null,
            invoice_status: null,
            ibps_transaction_no:'',
            po_number:'',
            view:'',
            sortByColumn: sortByColumn.value,
            sortBy: sortBy.value,
            search: search.value,
        })
        const form_fields = reactive({
        transaction_id: "",
        });
        const disabled_supplier = ref(false);
        
        const index = () => {
            store.dispatch('Option/getAllSites')
            store.dispatch('Option/getAllPaymentPortalStatus')
        };

        const createRecord = () => {
            router.push("/invoice/create");
        };

        const editRecord = (record: any) => {
            const { transaction_id } = toRefs(form_fields);
            transaction_id.value = record.transaction_id;
            visible.value = true
        };

        const deleteRecord = (record: any) => {
            store.dispatch("VendorInvoice/destroy", record.id);
        };

        const handleSaving = () => {
            form.search = search.value;
            // const { id, org_id, vendor_id, vendor_id_old, invoice_date, invoice_no, ibps_transaction_no, po_number, view } = toRefs(form)
            const new_form = Object.assign({}, form);


            if(selectedOrgIdFromVendor.value != '') {
                new_form.org_id = selectedOrgIdFromVendor.value;
            }
            console.log(form)
            vendorOptions.map((item)=> {
                if(item.value === new_form.vendor_id) {
                    new_form.vendor_id = item.vendor_id
                }
            })

            
            items.value.data.length = 0
            if(new_form.view) {
                if(new_form.view == 'AP'){
                    if(new_form.org_id){
                        loading.value = true
                        new_form.vendor_id_old = new_form.vendor_id_old === '' || new_form.vendor_id_old === null ? '0':new_form.vendor_id_old
                        
                        store.dispatch("Dashboard/index", new_form).then((res:any) => {
                            if(res.data.data.length === 0){
                                items.value.data.length = 0
                                notification['error']({
                                message: 'No record found',
                                description: ''
                                });
                            } else {
                                if(current_page.value > res.data.last_page) {
                                    current_page.value = res.data.last_page
                                    handleSaving()
                                }
                            }
                            loading.value = false
                        })
                    }else{
                        notification['error']({
                        message: 'Please select Organization Name',
                        description: ''
                        });
                    }
                }else if(new_form.view == 'PCRF'){
                    if(new_form.org_id){
                        loading.value = true
                        store.dispatch("Dashboard/pcrf", new_form).then((res:any) => {
                        if(res.data.data.length === 0){
                            items.value.data.length = 0
                            notification['error']({
                            message: 'No record found',
                            description: ''
                            
                            });
                        } else {
                            if(current_page.value > res.data.last_page) {
                                current_page.value = res.data.last_page
                                handleSaving()
                            }
                        }
                        loading.value = false
                        })
                    }else{
                        notification['error']({
                        message: 'Please select Organization Name',
                        description: ''
                        });
                    }
                } else if(new_form.view == 'TCE'){
                if(new_form.org_id){
                    loading.value = true
                    store.dispatch("Dashboard/tce", new_form).then((res:any) => {
                        if(res.data.data.length === 0){
                            items.value.data.length = 0
                            notification['error']({
                            message: 'No record found',
                            description: ''
                            
                            });
                        } else {
                            if(current_page.value > res.data.last_page) {
                                current_page.value = res.data.last_page
                                handleSaving()
                            }
                        }
                        loading.value = false
                    })
                }else{
                    notification['error']({
                    message: 'Please select Organization Name',
                    description: ''
                    });
                }
                }
            }else{
                notification['error']({
                message: 'Please Select View',
                description: ''
                });
            }
            vendorOptions.map((item)=> {
                if(item.id_w_vendor_id === selectedIdVendor.value) {
                form.vendor_id = item.id_w_vendor_id
                }
            })
            console.log('changes')
            console.log(form)
        }

        const onChangeView= (view:any) => {
            disabled_supplier.value = view !='AP'? true:false  
        }

        const filterOption = (input:any, option:any) => {
            return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }

        const filterRecord = (payload: any) => {
            
            
            if(payload.search != undefined) {
                search.value = payload.search;
            }
            current_page.value = payload.page;

            const new_form = Object.assign({}, form);
            if(selectedOrgIdFromVendor.value != '') {
                new_form.org_id = selectedOrgIdFromVendor.value;
            }
            vendorOptions.map((item)=> {
                if(item.value === new_form.vendor_id) {
                new_form.vendor_id = item.vendor_id
                }
            })
            if(new_form.vendor_id_old == '' || new_form.vendor_id_old == null) {
                new_form.vendor_id_old = '0';
            } 
        
        
            payload = {
                page: current_page.value,
                search: search.value,
                org_id: new_form.org_id,
                vendor_id: new_form.vendor_id,
                invoice_no:  new_form.invoice_no,
                vendor_id_old: new_form.vendor_id_old,
                view: new_form.view,
                sortByColumn: sortByColumn.value,
                sortBy: sortBy.value,
                invoice_status: new_form.invoice_status
            }

            if(form.view == 'AP'){
                items.value.data.length = 0
                loading.value = true
                store.dispatch("Dashboard/index", payload).then((res:any) => {
                    if(current_page.value > res.data.last_page) {
                        current_page.value = res.data.last_page
                        filterRecord([])
                    }
                    loading.value = false
                })
            }else if(form.view == 'PCRF'){
                items.value.data.length = 0
                loading.value = true
                store.dispatch("Dashboard/pcrf", payload).then((res:any) => {
                    if(current_page.value > res.data.last_page) {
                        current_page.value = res.data.last_page
                        filterRecord([])
                    }
                    loading.value = false
                })
            }else if(form.view == 'TCE'){
                items.value.data.length = 0
                loading.value = true
                store.dispatch("Dashboard/tce", payload).then((res:any) => {
                    if(current_page.value > res.data.last_page) {
                        current_page.value = res.data.last_page
                        filterRecord([])
                    }
                    loading.value = false
                })
            }
        }
        
        var vendorOptions: { value: string; label: string; disabled: boolean; vendor_id: string; vendor_id_old: string; org_id: string; id_w_vendor_id: string }[] = [];
        const vendor_fetching = ref(false);

        const handleSearchVendor = debounce(value => {
            vendor_fetching.value = false;
            fetchVendors(value)
        }, 500);

        const fetchVendors = (value:any) => {
            removeSelectedVendor()
            vendorOptions.length = 0
            vendor_fetching.value = true;
            const payload = {search:value, org_id: form.org_id };
            store.dispatch('Option/getAllVendorPerOrg', payload).then((res) => {
                res.forEach((element:any) => {

                vendorOptions.push({
                    value: element.id + element.vendor_id,
                    label: element.org_code ? element.vendor_name + '('+ element.org_code +')' : element.vendor_name ,
                    disabled: false,
                    vendor_id: element.vendor_id,
                    vendor_id_old: element.vendor_id_old ?? 0,
                    org_id: element.org_id,
                    id_w_vendor_id: element.id + element.vendor_id
                });
                });
                vendor_fetching.value = false;
            })
        };

        const removeSelectedVendor = () => {
            form.vendor_id = '';
            form.vendor_id_old = '';
            selectedOrgIdFromVendor.value = '';
            selectedIdVendor.value = '';
        }

        const getSelectedVendor = (val:any) => {

            vendorOptions.map((item)=> {
                if(item.value === val) {
                form.vendor_id_old = item.vendor_id_old
                selectedIdVendor.value = item.id_w_vendor_id
                selectedOrgIdFromVendor.value = item.org_id
                }
            })
        }

        const handleOrgChange = (payload: any) => {
            fetchVendors(null)
        }

        const handleTableChange =  (sorter:any) => {

            sortByColumn.value = sorter.field;
            sortBy.value = sorter.order;
            filterRecord({});
        }

        onMounted(() => {
            // showVendor();
            index();
            loading.value = false
            items.value.data = []
            fetchVendors(null)
        });

        const items = computed(() => store.getters["Dashboard/items"]);
        // const loading = computed(() => store.getters["Dashboard/status"]);
        const sites = computed(() => store.getters['Option/all_sites'])
        const invoice_statuses = computed(() => store.getters['Option/all_payment_portal_status'])

        return {
        items,
        visible,
        loading,
        fields,
        form_action,
        showUploadForm,
        form,
        sites,
        invoice_statuses,
        form_fields,
        disabled_supplier,
        ranges: {
            Today: [dayjs(), dayjs()] as RangeValue
        },
        createRecord,
        editRecord,
        deleteRecord,
        handleSaving,
        handleOrgChange,
        handleTableChange,
        filterOption,
        onChangeView,
        filterRecord,
        handleSearchVendor,
        vendor_fetching,
        vendorOptions,
        getSelectedVendor
        };
    },
    });
